import React, { useEffect, useState } from 'react'
import { Footer } from '../../../common/footer/footer';
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'aos/dist/aos.css';
import close_btn from '../../../../assets/images/white_cross.svg';
import '../globalMainSearchArticles/globalMainSearchArticles.model.css';
import { Pagination } from '../../../common/pagination/uiPagination';
import { ArticlesCardJSX } from '../../../common/articlesCard/articlesCard';
import Filter from '../../../../shared/filter.jsx';
import { useTranslation } from "react-i18next";

const GlobalMainSearchArticlesJsx = (props) => {
  const {
    articleData,
    onPaginationButtonClick,
    hitSearch,
    searchOfferByKeyword,
    selectAll,
    selectAllHit,
    getAllFeauturedOffersData,
    selectCategory,
    selectSubCategory,
    subCategories,
    categories,
    disableSelectAll,
    categoryData,
    page
  } = props;
  const itemsPerPage = 10

  const [currentPage] = useState(1);
  const [filterrMenuOpen, setFilterrMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  const checkMobileView = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  useEffect(() => {
    checkMobileView(); // Initial check
    window.addEventListener('resize', checkMobileView); // Listen for window resize

    return () => {
      window.removeEventListener('resize', checkMobileView); // Clean up event listener
    };
  
  }, [])

  const { t } = useTranslation();

  const currentItems = articleData?.body?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );
  const getProperName = (data) => {
    if (data === "featured") {
      return "Latest"
    }else if(data === "main_news"){
      return "Featured"
    }else if(data === "glossory"){
      return "Curated Wisdom"
    }else if(data === "trending"){
      return "Trending "
    }else{
      return params.search
    }
  }
  // featured - curated, main_news - featured, glossory - glossory, trending - latest
  return (
    <>
      <section className="homecustom homecustomsearchfull">
        <section className="offersearch">
          <div className="container">
            <div className="customsearchblock">
              <input type="search" defaultValue={params.search} placeholder="" onChange={searchOfferByKeyword}
              />
              <button className="headersearch" onClick={() => hitSearch()}>{t("COMMON.SEARCH")}</button>
            </div>
            <h2>{t("ARTICLES.SEARCHTITLE")}</h2>
            <h4>{t("ARTICLES.SEARCHDESH")}</h4>
          </div>
        </section>
      
        <section className="searchresultsection">
        <div className="filtergs">
         
         {isMobile ? <div className="mobile-filter sortingdiv">
          <div className="container">
            <div className="d-flex mobiledrop">
           
              <div className="dropshortby">
                <button className="btn btn-secondary dropdown-toggle"  onClick={() => {setFilterrMenuOpen(!filterrMenuOpen)}} type="button" id="dropdownShortBy">
                {t("COMMON.FILTER")}
                </button>
                <div class={`${filterrMenuOpen===true ? 'open-active' : ''} filter-wrap`} aria-labelledby="dropdownShortBy">
                <button className="close_btn btm-btn" onClick={() => { setFilterrMenuOpen(!filterrMenuOpen) }} ><img src={close_btn} alt={t("CUSTOMERINTEREST.CLOSEBUTTON")} /></button>
                  <Filter
                    categoryData={categoryData}
                    selectAll={selectAll}
                    selectAllHit={selectAllHit}
                    selectCategory={selectCategory}
                    selectSubCategory={selectSubCategory}
                    subCategories={subCategories}
                    categories={categories}
                    disableSelectAll={disableSelectAll}

                  />
                </div>
              </div>
            </div>
          </div>
        </div> : <>
          <Filter
            categoryData={categoryData}
            selectAll={selectAll}
            selectAllHit={selectAllHit}
            getAllFeauturedOffersData={getAllFeauturedOffersData}
            selectCategory={selectCategory}
            selectSubCategory={selectSubCategory}
            subCategories={subCategories}
            categories={categories}
            disableSelectAll={disableSelectAll}

          />
        
          </>}
   
       </div>
          <div className="expertsection martop30 mb-5">
            <div className="container articlemain">
              <div className="articlehading">
                <h2> {params["type"] != null ? `${getProperName(params["type"])} ${t("ARTICLES.EMPTYTITLE")}` : params.search === "" || params.search === null ? `${t("ARTICLES.EMPTYTITLE")}` : `“${params.search}” ${t("ARTICLES.TITLE")}`}</h2>
              </div>
              {
                currentItems?.length > 0 ?
                  currentItems?.map(article => {

                    return  <ArticlesCardJSX blogslug={article?.slug}
                    blogimage={article?.image}
                    blogtitle={article?.title}
                    blogcat={article?.cats.map((cat) => cat.name).join(',')}
                    blogshort_content={article?.short_content}
                    articleauthor={article?.author}
                    articledatepublish={article?.date_publish}
                    isSerchArticle={true} />
                    // <ArticlesCardJSX
                    //   blogslug={article?.slug}
                    //   blogimage={article?.image}
                    //   blogtitle={article?.title}
                    //   blogshort_content={article?.short_content}
                    //   articleauthor={article?.author}
                    //   articledatepublish={article?.date_publish}
                    //   blogauthor_image={article?.author_image}
                    //   isSerchArticle={true}
                     
                    // />

                  }) : <div className="dropdefault text-center">
                    <h5>{t("ARTICLES.NOARTICLEFOUND")} </h5>
                  </div>
              }
            </div>
            {currentItems?.length > 0 && <section className="newpagination" > <Pagination
              currentPage={currentPage}
              page={page}
              itemsPerPage={itemsPerPage}
              allOffersData={articleData?.body}
              currentItems={currentItems}
              onPaginationButtonClick={onPaginationButtonClick}

            /></section>}
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
};

export default GlobalMainSearchArticlesJsx;